const columns = [
    {
        label: 'Invoice No.',
        name: 'invoiceNo',
        isNumber: true,
        isInt:true
    },
    {
        label: 'Date',
        name: 'date',
        isDate: true
    },
    {
        label: 'Revenue (Kes)',
        name: 'revenue',
        isNumber: true
    },
    {
        label: 'Expenditure (Kes)',
        name: 'expenditure',
        isNumber: true
    },
    {
        label: 'Arrears BF (Kes)',
        name: 'arrearsBF',
        isNumber: true
    },
    {
        label: 'Arrears CF (Kes)',
        name: 'arrearsCF',
        isNumber: true
    },

    {
        label: 'Vacant Units',
        name: 'vacant',
        isNumber: true,
        isInt:true
    },
    {
        label: 'Action',
        name: 'action'
    }
]
export default columns